import React, { useState } from 'react';
import styled from 'styled-components';
import { Row, Modal, Button, Space, Image, Col, Tooltip } from 'antd';
//import AmazonSvg from 'assets/icons/Amazon';
import CanadaPostSVG from 'assets/icons/CanadaPost';
import PurolatorSVG from 'assets/icons/Purolator';
import SheinSvg from 'assets/icons/Shein';
import upsPic from 'assets/images/ups.png';
import fedExPic from 'assets/images/fedEx.png';
import uspsPic from 'assets/images/usps.png';
//import purolatorPic from 'assets/images/logotrans.gif';
import otherShipping from 'assets/images/otherShipping.png';
import temuPic from 'assets/images/temu.png'
import dhlPic from 'assets/images/dhl.png';
import { CloseOutlined } from '@ant-design/icons';
import { ButtonIcon } from 'components/common/styles';

interface CreateLotProps {
  visible: boolean;
  onHide: () => void;
  onRefresh: (selected: number) => void;
  isShow: boolean;
}

const RowContainer = styled(Row)`
  & .h-50 {
    height: 50px;
  }

  & .h-56 {
    height: 56px;
  }

  & .img-100p .ant-image {
    height: 100% !important;
  }

  & .img-ctn {
    border: 1px solid #ECECEC;
  }

  & .img-ctn.with-border {
    border: none;
    /*border: 1px solid #D9D9D9;*/
  }

  & .img-ctn.no-img-border .ant-image,
  & .img-ctn .no-img-border .ant-image {
    display: inline-block;
    overflow: hidden;
  }

  & .img-ctn.no-img-border .ant-image img,
  & .img-ctn .no-img-border .ant-image img {
    width: 100%;
    height: auto;
    transform: scale(calc(1 + (6px / 100%)));
    transform-origin: center center;
  }

  & .img-ctn .no-img-border {
    /*border: 1px solid #D9D9D9;*/
    overflow: hidden;
  }

  & .img-ctn.selected {
    background-color: #ECECEC;
  }

  & .img-ctn .no-img-border.selected,
  & .img-ctn.with-border.selected {
    /*border: 1px solid #006DFF;*/
  }

  & .img-scale-0 {
    transform: none !important;
  }

  & .img-scale-1_4 {
    transform: scale(1.4) !important;
  }

  & .img-scale-1_8 {
    transform: scale(1.8) !important;
  }

  & .p-10-0 {
    padding: 10px 0;
  }

  & .p-7-0 {
    padding: 7px 0;
  }

  & .w-100 {
    width: 100px !important;
  }

  & .w-100p {
    width: 100%;
  }
`;

const SelectCarrierDialog = (props: CreateLotProps) => {
  const { onHide, onRefresh, visible, isShow } = props;
  const [selected, setSelected] = useState(1);

  return (
    <Modal
      title="Select a carrier"
      centered
      visible={visible}
      maskClosable={false}
      width={800}
      destroyOnClose={true}
      onCancel={onHide}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button
              id="select_carrier_button"
              key="submit"
              type="primary"
              onClick={() => onRefresh(selected)}
            >
              <ButtonIcon className="bi-hand-index-thumb" />
              Select
            </Button>
            <Button onClick={onHide} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
      <RowContainer>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="FedEx">
            <Row className={selected === 1 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 1 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <Image
                  id="fedex_img"
                  preview={false}
                  src={fedExPic}
                  alt="FedEx"
                  placeholder="FedEx"
                  onClick={() => setSelected(1)}
                  width={100}
                  //style={selected === 1 ? { border: '1px solid #006dff' } : {}}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="UPS">
            <Row className={selected === 2 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 2 ? 'h-56 img-100p no-img-border selected' : 'h-56 img-100p no-img-border'}>
                <Image
                  alt="UPS"
                  className="img-scale-1_8 w-100"
                  id="ups_img"
                  onClick={() => setSelected(2)}
                  placeholder="UPS"
                  preview={false}
                  src={upsPic}
                  //width={100}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="USPS">
            <Row className={selected === 3 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 3 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <Image
                  //style={selected === 3 ? { border: '1px solid #006dff' } : {}}
                  alt="USPS"
                  className="img-scale-1_4"
                  id="usps_img"
                  onClick={() => setSelected(3)}
                  placeholder="USPS"
                  preview={false}
                  src={uspsPic}
                  width={100}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Purolator International">
            <Row className={selected === 4 ? 'p-10-0 w-100p img-ctn selected' : 'p-10-0 w-100p img-ctn'} justify="center">
              <div className={selected === 4 ? 'h-50 img-ctn with-border selected' : 'h-50 img-ctn with-border'} onClick={() => setSelected(4)}>
                <PurolatorSVG
                  con="International"
                  height={50}
                  width={216}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        {isShow && <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="DHL">
            <Row className={selected === 5 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 5 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <Image
                  alt="DHL"
                  className="img-scale-0"
                  id="dhl_img"
                  onClick={() => setSelected(5)}
                  placeholder="DHL"
                  preview={false}
                  src={dhlPic}
                  width={162}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>}
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Temu">
            <Row className={selected === 6 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 6 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <Image
                  id="temu_img"
                  preview={false}
                  src={temuPic}
                  alt="temu"
                  onClick={() => setSelected(6)}
                  style={{ height: 54, width: 54 }}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="CANADA POST">
            <Row className={selected === 7 ? 'p-10-0 w-100p img-ctn selected' : 'p-10-0 w-100p img-ctn'} justify="center">
              <div className={selected === 7 ? 'h-50 img-ctn with-border selected' : 'h-50 img-ctn with-border'} onClick={() => setSelected(7)}>
                <CanadaPostSVG
                  width={50}
                  height={50}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        {/*<Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Amazon">
            <div
              style={
                selected === 8
                  ? {
                      border: '1px solid #006dff',
                      width: 100,
                      textAlign: 'center',
                    }
                  : { width: 100, textAlign: 'center' }
              }
            >
              <div onClick={() => setSelected(8)} style={{height: 50}}>
                <AmazonSvg
                  width={100}
                  height={50}
                />
              </div>
            </div>
          </Tooltip>
        </Col>*/}
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Shein">
            <Row className={selected === 9 ? 'p-10-0 w-100p img-ctn selected' : 'p-10-0 w-100p img-ctn'} justify="center">
              <div className={selected === 9 ? 'h-50 img-ctn with-border selected' : 'h-50 img-ctn with-border'} onClick={() => setSelected(9)}>
                <SheinSvg
                  width={100}
                  height={50}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Shein MarketPlace Vendor">
            <Row className={selected === 10 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === 10 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <img
                  alt="Shein MarketPlace Vendor"
                  height={50}
                  src="/imgs/SheinMarketplace.png"
                  style={{objectFit: 'contain'}}
                  width={98}
                  onClick={() => setSelected(10)}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Purolator Canada">
            <Row className={selected === 11 ? 'p-10-0 w-100p img-ctn selected' : 'p-10-0 w-100p img-ctn'} justify="center">
              <div className={selected === 11 ? 'h-50 img-ctn with-border selected' : 'h-50 img-ctn with-border'} onClick={() => setSelected(11)}>
                <PurolatorSVG
                  con="Canada"
                  conX={211}
                  height={50}
                  width={216}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
        <Col span={8} style={{ display: 'flex', justifyContent: 'center' }}>
          <Tooltip placement="rightTop" title="Other">
            <Row className={selected === -1 ? 'p-7-0 w-100p img-ctn selected' : 'p-7-0 w-100p img-ctn'} justify="center">
              <div className={selected === -1 ? 'h-56 no-img-border selected' : 'h-56 no-img-border'}>
                <Image
                  id="other_img"
                  preview={false}
                  src={otherShipping}
                  alt="Other"
                  onClick={() => setSelected(-1)}
                  style={{ height: 50 }}
                />
              </div>
            </Row>
          </Tooltip>
        </Col>
      </RowContainer>
    </Modal>
  );
};

export default SelectCarrierDialog;
